export default __webpack_public_path__ + "static/media/Raleway-Regular.6b2eb300.woff";